// ProductPhoto.js

import React, {Component} from 'react';
import { Button, Form , Table , Container, Row, Col ,  ButtonToolbar, Overlay, Popover } from 'react-bootstrap';
import Config from '../Config';
import ScrollArea from 'react-scrollbar';
import Modal from 'react-awesome-modal';

class RowItem extends Component {
    static defaultProps = {
        key: null,
        item: null,
        enable: false,
        onPress: () => { },
        onChange: () => { },
    }
    constructor(props) {
        super(props);
        this.state = {
            item : this.props.item
        };
    }
    
    componentWillReceiveProps(nextProps){
        // console.log("componentWillReceiveProps: " + JSON.stringify(nextProps));
        this.setState( { 
            item : nextProps.item
        } );
    }

    handleRowClick = () => {
        this.props.onPress(this.props.item);
        event.preventDefault();
    }

    render(){
        return (
            <tr onClick={this.handleRowClick}>
            <td>{this.props.item.ID}</td>
            <td>{this.props.item.IMAGENAME}</td>
            <td>{this.props.item.PRINTYN}</td>
            <td>{this.props.item.WIDTH}</td>
            <td>{this.props.item.HEIGHT}</td>
            </tr>
        );
    }
};

export default class ProductPhoto extends Component {
    static defaultProps = {
        item: null,
        images : null,
        enable: false,
        onPress: () => { },
    }
    constructor(props) {
        super(props);
        this.timer = null;
        this.locals = ["Kor","Eng","Jpn","Chn"];
        this.emptyItem = {
            ID: 0,
            PCODE: "0000",
            LCODE: "",
            TITLE : "",
            RTSEC : "",
            THUMBNAIL : ""
        }
        this.state = {
            timages : [],
            rowlist : [],
            answervisible : false,
            enable : true,
            item : this.props.item,
            images : this.props.images,
            language : this.locals[0],
            details : [],
            loading : false,
            S3ButtonText : 'S3에서 가져오기',
            s3ButtonDisabled : false
        };
    }
        
    componentWillReceiveProps(nextProps){
        // console.log("componentWillReceiveProps: " + JSON.stringify(nextProps));
        this.setState( { item : nextProps.item ,  images : nextProps.images } );
        this.refreshGetInfo();
    }

    refreshGetInfo() {
        if ( this.timer )
            clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.handleGetInfo(null);
        }, 500);
    }

    handleClose() {
        this.setState({answervisible: false });
    }

    handleGetInfo(event) {
        Config.fetchData('productphoto' , {
            PCODE : this.state.item.PCODE
        }, (result, count) => {
            console.log('productphoto=', result);
            this.setState({details : result} , () => {
                this.handleChangeDetail();
            })            
        }, true);         
    }

    handleChangeDetail() {
        this.setState( { rowlist: this.state.details });
    }

    
    handleSubmit(event) {
        var result = confirm("저장 하시겠습니까?");
        if(result){

            var arrData = [];
            var list = this.state.rowlist;
            for(var i = 0 ; i< list.length ; ++i )
            {
              arrData.push( [ list[i].PCODE, list[i].IMAGENAME, list[i].PRINTYN, list[i].WIDTH, list[i].HEIGHT ])
            }

            Config.fetchData('insproductphoto' , {
                PCODE: this.state.item.PCODE,
                DATA : arrData
            }, (result, count) => {
                console.log('insproductphoto=', count);
                this.refreshGetInfo();
            }, true);    
        }
        event.preventDefault();
    }

    handleRemove(event) {
        var result = confirm("삭제 하시겠습니까?");
        if(result){
            Config.fetchData('delproductphoto' , {
                PCODE : this.state.item.PCODE
            }, (result, count) => {
                console.log('delproductphoto=', count);
                this.refreshGetInfo();
            }, true);    
        }
        event.preventDefault();
    }

    handleGetFromS3(event) {
        this.setState({S3ButtonText : "파일 가져오는 중...", s3ButtonDisabled : true});

        Config.fetchData('getproductfiles' , {
            PCODE : this.state.item.PCODE,
            FOLDER : '/pthumbs'
        }, (result, count) => {
            console.log('getproductphoto=', result);
            var imagelist = [];
            for(var i=0;i<result.length;++i)
            {
                var item = {...this.emptyItem};
                item.ID = i;
                item.PCODE = this.state.item.PCODE;
                item.IMAGENAME = result[i].name;
                item.PRINTYN = result[i].PRINTYN;
                item.WIDTH = result[i].WIDTH;
                item.HEIGHT = result[i].HEIGHT;
                imagelist.push( item );
            }
            this.setState({rowlist : imagelist });
            this.setState({S3ButtonText : "S3에서 가져오기", s3ButtonDisabled : false});        
        }, true); 
        event.preventDefault();
    }


    handleRowClick = () => {
        event.preventDefault();
    }



    render(){
        let scrollbarStyles = {borderRadius: 5};
        return (
            <div className="box" >
                <div className="row" style={{  margin: 10 }}>
                    <div className="col-md-12">
                    <Button disabled={this.state.s3ButtonDisabled} variant="primary" onClick={this.handleSubmit.bind(this)}>저장</Button>
                    <Button disabled={this.state.s3ButtonDisabled} variant="primary" onClick={this.handleGetFromS3.bind(this)}>{this.state.S3ButtonText}</Button>
                    <Button disabled={this.state.s3ButtonDisabled} variant="primary" onClick={this.handleRemove.bind(this)}>삭제</Button>
                    </div>
                </div>
                <div className="row" style={{  margin: 10 }}>
                    <div className="col-md-6">
                        <Form.Group as={Col}  controlId="exampleForm.ControlInput1">
                            <Form.Label>상품코드</Form.Label>
                            <Form.Control type="title" placeholder="코드를 입력하세요." value={this.state.item.PCODE}  />
                        </Form.Group>
                    </div>
                </div>
                <div className="row" style={{  margin: 10 }}>
                    <hr/>
                </div>
                <div className="row" style={{  margin: 10 }}>
                    <ScrollArea style={{  width: '100%' , height: 500 }}
                        className="area"
                        contentClassName="content"
                        verticalScrollbarStyle={scrollbarStyles}
                        verticalContainerStyle={scrollbarStyles}
                        horizontalScrollbarStyle={scrollbarStyles}
                        horizontalContainerStyle={scrollbarStyles}
                        smoothScrolling= {true}
                        minScrollSize={5}
                        onScroll={this.handleScroll}
                        >
                    <Table striped bordered hover>
                    <thead>
                        <tr>
                        <td>#</td>
                        <td>파일명</td>
                        <td>인화여부</td>
                        <td>넓이</td>
                        <td>높이</td>
                        </tr>
                    </thead>
                    <tbody>

                    { this.state.rowlist.map((item, index) =>
                        <RowItem key={index} item={item} onPress={this.handleRowClick.bind(this)} />
                    )}

                    </tbody>
                    </Table>
                    </ScrollArea>
                </div>    

 
            </div>

        );
    }
};





// WEBPACK FOOTER //
// src/components/ProductPhoto.js